<template>
  <modal-form
    class="custom-grid"
    :hideFooter="isHistorico"
    v-model="show"
    size="xl"
    ref="modalAnalise"
  >
    <template v-slot:title>Bureau</template>
    <template v-slot:body>
      <v-stepper v-if="hasData" alt-labels v-model="currentStep" flat tile class="custom-stepper">
        <v-stepper-header class="custom-stepper-header">
          <v-stepper-step
            v-for="(bureau, index) in bureaus"
            :key="'step-'+index"
            editable
            :step="index+1"
            :complete="currentStep > index+1"
          >
            {{ getBureauName(bureau.bureau) }}
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items class="custom-stepper-items">
          <v-stepper-content
            v-for="(bureau, index) in bureaus"
            :key="'content-'+index"
            :step="index+1"
          >
            <core-form>
              <BureauDefault
                :bureau="bureau"
                :contexto="contexto"
                :onboarding="onboardingAtual"
                @reconsulta="reconsultar"
                :isHistorico="isHistorico"
                :codigoContaSolicitacaoCriacao="model.codigoContaSolicitacaoCriacao"
              />
            </core-form>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <v-progress-circular v-else indeterminate color="primary"></v-progress-circular>
    </template>
    <template v-slot:actions>
      <div class="flex-grow-1"></div>
      <v-btn color="white" @click="response">CANCELAR</v-btn>
    </template>
  </modal-form>
</template>

<script>
export default {
  props: {
    contexto: String,
    isHistorico: Boolean
  },
  components: {
    BureauDefault: () => import('./tabs/Bureau')
  },
  data() {
    return {
      acaoOnboarding: 'acao',
      show: false,
      model: {},
      onboardingAtual: {},
      bureaus: [],
      currentStep: 1,
      hasData: false,
      loading: true
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.currentStep = 1;
      }
    }
  },
  methods: {
    getBureauName(bureauType) {
      const bureau = this.$api.Arrays.TipoBureau.find(arr => arr.value == bureauType);
      return bureau ? bureau.text.replace('PJ', '') : '';
    },
    
    openModal(curr) {
      const th = this;
      document.addEventListener('keydown', th.handleKeydown);
      th.show = true;
      th.limparCampos();
      th.currentStep = 1;
      th.loading = true;
      th.hasData = false;

      Object.assign(th.model, curr);
      th.acaoOnboarding = th.obterTipoPermissao(th.model.tipoPermissao);

      th.obterConsultas();
    },
    
    obterTipoPermissao(tipoPermissao) {
      const tipos = {
        1: 'criação',
        2: 'edição',
        4: 'vínculo',
        5: 'vínculo'
      };
      return tipos[tipoPermissao] || '';
    },
    
    response() {
      this.closeModal();
    },
    
    closeModal() {
      const th = this;
      th.limparCampos();
      th.show = false;
      th.$emit('close');
      document.removeEventListener('keydown', th.handleKeydown);
    },
    
    limparCampos() {
      this.model = {};
      this.onboardingAtual = {};
      this.bureaus = [];
      this.currentStep = 1;
      this.hasData = false;
      this.loading = true;
    },
    
    reconsultar() {
      const th = this;
      th.acaoOnboarding = th.obterTipoPermissao(th.model.tipoPermissao);
      th.obterConsultas();
    },
    
    async obterConsultas() {
      const th = this;
      try {
        const response = await th.$api['analise-onboarding']
          .ObterConsultaAnaliseInicial(th.model.codigo);
        
        if (!th.$api.UI.PostLoadData(response)) return;

        th.onboardingAtual = { ...response.onboarding };
        th.bureaus = [...(response.detalhesBureaus || [])].sort(th.ordenarBureaus);
        
        th.hasData = th.bureaus.length > 0;
        th.loading = false;
        
        th.$nextTick(() => {
          th.currentStep = 1;
        });
      } catch (error) {
        console.error('Erro ao obter consultas:', error);
        th.loading = false;
      }
    },
    
    ordenarBureaus(a, b) {
      return a.bureau - b.bureau;
    },
    
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    }
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.v-stepper__step__step {
  display: none;
}

.v-stepper--alt-labels .v-stepper__step {
  align-items: start;
  flex-basis: 0;
  padding: 20px;
  min-width: 180px;
}

.custom-stepper {
  display: flex;
}

.custom-stepper-header {
  flex-direction: column;
  justify-content: start;
  flex: 0 0 20%;
  max-height: 60vh;
  flex-wrap: nowrap;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 180px;
}

.custom-stepper-items {
  flex-direction: column;
  flex: 0 0 80%;
  height: 60vh;
  overflow-y: auto;
}

.v-stepper__label {
  display: block !important;
}
</style>